import { NgModule } from "@angular/core";
import { RouterModule, Routes, PreloadAllModules } from "@angular/router";

import { FullLayoutComponent } from "./layouts/full/full-layout.component";
import { ContentLayoutComponent } from "./layouts/content/content-layout.component";

import { fullRoutes } from "@shared/routes/full-layout.routes";
import { CONTENT_ROUTES } from "@shared/routes/content-layout.routes";
import { AuthRouthGuard } from "@shared/guards/route-auth.guard";
import { KeycloakCallbackComponent } from "./core/keycloak-callback.component";
import { LicenseGuard } from "./shared/guards/license.guard";

const routes: Routes = [
  {
    path: "",
    redirectTo: "auth/signin",
    pathMatch: "full",
  },
  {
    path: 'kc/callback',
    component: KeycloakCallbackComponent,
  },
  {
    path: "",
    component: FullLayoutComponent,
    data: { title: "full Views" },
    children: fullRoutes,
  },
  {
    path: "",
    component: ContentLayoutComponent,
    data: { title: "content Views" },
    children: CONTENT_ROUTES,
  },
];

@NgModule({
  providers: [AuthRouthGuard,LicenseGuard],
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      relativeLinkResolution: "legacy",
    }),
  ],
  // imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
